import CreationModalProgressContextProvider from '@app/src/context/CreationModalProgressContextProvider'
import { useDialogState } from '@app/src/hooks/mui-hooks'
import BulkCreateExpectationModal from '@app/src/pages/ResourceCollection/Collections/Provider/BulkCreateExpectation/BulkCreateExpectationModal'
import type { Provider } from '@app/src/types/organizations'
import type { AssessmentTemplate } from '@app/src/types/resourceExplorer'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'

export function useBulkCreateExpectation(providers: Provider[], preselectedAssessmentTemplate?: AssessmentTemplate) {
  const [isOpen, open, close] = useDialogState(false)
  const { baselineExpectation: isEnabled } = useFlags()

  const modal = isOpen ? (
    <CreationModalProgressContextProvider>
      <BulkCreateExpectationModal
        open
        onClose={close}
        initialProviders={providers}
        preselectedAssessmentTemplate={preselectedAssessmentTemplate}
      />
    </CreationModalProgressContextProvider>
  ) : null

  return { isEnabled: Boolean(isEnabled), open, modal }
}
